// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ZfhB0","buttons":"Card_buttons__j8Y+s","active":"Card_active__lM9pH","remove":"Card_remove__31Ijr","star":"Card_star__eRTeX"};